let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kl1ZQ")).then(() => parcelRequire('kx7O4'));